
type Command = { type: string; data?: unknown };

type Handler = (data: any) => Command[] | void; // returns commands to emit or nothing

const registry = new Map<string, Handler>();

export function register(type: string, h: Handler) { registry.set(type, h); }
export function routeIncoming(msg: { type: string; data: any }): Command[] {
  try {
    return registry.get(msg.type)!(msg.data) ?? [];
  } catch (error) {
    console.error(`Error handling message type "${msg.type}":`, error);
    return [];
  }
}
